import api from "../helpers/util";

export const fetchSpecies = async () => {
  try {
    const response = await api.get("/species");
    return response?.data?.result ?? "No species found.";
  } catch (error) {
    console.log("species fetch err", error);
    throw new Error("Error fetching species:", error);
  }
};
